
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import LanguageSwitcher from '@/core/components/LanguageSwitcher.vue';
import { LoginFindToken } from '@/courier/application/uses_cases/login/search/findtoken/LoginFindToken';
import { showAlert } from '@/core/plugins/Notifications';
@Component({
  name: 'Login',
  components: { LanguageSwitcher }
})
export default class LoginN extends Vue {
  @Inject(TYPES.LOGIN_USER)
  loginFindToken!: LoginFindToken;

  //Data
  isLoading = false;

  //Formulario
  form: any = {
    username: '',
    password: ''
  };

  //Getter para obtener el año actual
  get currentYear() {
    return new Date().getFullYear();
  }

  //Metodo invocado para validar inputs
  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }): any {
    return dirty || validated ? valid : null;
  }

  //Metodo para limpiar los campos
  clearForm() {
    this.form.username = '';
    this.form.password = '';
  }

  //Funcion invocada para hacer login
  async Login() {
    this.isLoading = true;
    const payload: any = {
      username: this.form.username.trim(),
      password: this.form.password.trim()
    };

    try {
      const response: any = await this.loginFindToken.execute(payload);
      if ('error' in response || 'message' in response) {
        showAlert('warning', this.$t('generalmessage.ERROR_MESSAGE_LOGIN'));
      } else {
        this.$toasted.show(this.$t('general.welcome') + ` ${response.customerName} !`);
      }
      this.isLoading = false;
      return response;
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }
}
